<template>
  <div>
    <Head :title="__('User Login Log')" />

    <!-- Online Now -->
    <div class="bg-white rounded-xl shadow-sm border border-gray-100 mb-4">
      <div class="login-log-section-header px-5 py-4 border-b flex items-center gap-2">
        <span class="w-2.5 h-2.5 rounded-full bg-green-500 inline-block"></span>
        <h2 class="font-semibold text-gray-800">{{ __('Online Now') }} <span class="text-green-500">({{ onlineUsers.length }})</span></h2>
      </div>
      <div class="p-4">
        <div v-if="onlineUsers.length === 0" class="login-log-empty text-sm py-2">
          {{ __('No users currently online.') }}
        </div>
        <div v-else class="flex flex-wrap gap-3">
          <div v-for="user in onlineUsers" :key="user.id"
               class="login-log-online-card flex items-center gap-2 bg-green-50 border border-green-100 rounded-lg px-3 py-2">
            <div class="um-avatar w-8 h-8 flex-shrink-0">
              <img v-if="user.photo" :src="user.photo" class="w-full h-full object-cover" />
              <span v-else class="um-avatar-initials text-xs">{{ (user.name || '?')[0].toUpperCase() }}</span>
            </div>
            <div>
              <div class="text-sm font-medium text-gray-800 leading-tight">{{ user.name }}</div>
              <div class="text-xs text-gray-500">{{ user.role }}</div>
            </div>
            <span class="w-2 h-2 rounded-full bg-green-400 flex-shrink-0"></span>
          </div>
        </div>
      </div>
    </div>

    <!-- Login History -->
    <div class="bg-white rounded-xl shadow-sm border border-gray-100">
      <div class="login-log-section-header px-5 py-4 border-b flex items-center justify-between">
        <h2 class="font-semibold text-gray-800">{{ __('Login History') }}</h2>
        <search-input v-model="form.search" class="w-64" @reset="reset" />
      </div>
      <div class="overflow-x-auto">
        <table class="w-full whitespace-nowrap ticket_list">
          <tr class="text-left font-bold">
            <th>{{ __('User') }}</th>
            <th>{{ __('Role') }}</th>
            <th>{{ __('Login Time') }}</th>
            <th>{{ __('IP Address') }}</th>
            <th>{{ __('Status') }}</th>
          </tr>
          <tr v-for="log in logs.data" :key="log.id" class="hover:bg-gray-100 focus-within:bg-gray-100 ticket-row">
            <td class="border-t">
              <div class="flex items-center gap-2 px-4 py-2">
                <div class="um-avatar w-8 h-8 flex-shrink-0">
                  <img v-if="log.user && log.user.photo" :src="log.user.photo" class="w-full h-full object-cover" />
                  <span v-else class="um-avatar-initials text-xs">
                    {{ log.user ? (log.user.name || '?')[0].toUpperCase() : '?' }}
                  </span>
                </div>
                <div>
                  <div class="text-sm font-medium">{{ log.user ? log.user.name : '—' }}</div>
                  <div class="text-xs opacity-60">{{ log.user ? log.user.email : '' }}</div>
                </div>
              </div>
            </td>
            <td class="border-t capitalize">
              <div class="px-4 py-2 text-sm opacity-80">{{ log.user ? log.user.role : '—' }}</div>
            </td>
            <td class="border-t">
              <div class="px-4 py-2 text-sm opacity-80">{{ log.login_at }}</div>
            </td>
            <td class="border-t">
              <div class="px-4 py-2 text-sm font-mono opacity-60">{{ log.ip_address || '—' }}</div>
            </td>
            <td class="border-t">
              <div class="px-4 py-2">
                <span v-if="log.user && log.user.is_online"
                  class="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-700">
                  <span class="w-1.5 h-1.5 rounded-full bg-green-500"></span>
                  {{ __('Online') }}
                </span>
                <span v-else class="px-2 py-0.5 rounded-full text-xs font-semibold bg-gray-100 text-gray-500">
                  {{ __('Offline') }}
                </span>
              </div>
            </td>
          </tr>
          <tr v-if="logs.data.length === 0">
            <td class="login-log-empty px-4 py-4 border-t text-sm" colspan="5">{{ __('No login records found.') }}</td>
          </tr>
        </table>
      </div>
    </div>

    <pagination class="mt-6" :links="logs.links" />
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchInput from '@/Shared/SearchInput'

export default {
  components: {
    Head,
    Icon,
    Pagination,
    SearchInput,
  },
  layout: Layout,
  props: {
    filters: Object,
    logs: Object,
    onlineUsers: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(this.route('user_login_log'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
